import React from 'react'
import PropTypes from 'prop-types'

import asyncComponent from '../AsyncComponent'
import Headline from '../Article/Headline'
import Bodytext from '../Article/Bodytext'
import Meta from '../Post/Meta'
import Author from '../Post/Author'

const Share = asyncComponent(() =>
  import('../Post/Share')
    .then(module => {
      return module.default
    })
    .catch(error => {})
)

const Post = props => {
  const {
    post,
    post: {
      html,
      fields: { prefix },
      frontmatter: { title, author, category }
    },
    authornote,
    theme
  } = props

  return (
    <React.Fragment>
      <header>
        <Headline title={title} theme={theme} />
        <Meta prefix={prefix} author={author} category={category} theme={theme} />
      </header>
      <Bodytext html={html} theme={theme} />
      <footer>
        <Share post={post} theme={theme} />
        <Author note={authornote} theme={theme} />
      </footer>
    </React.Fragment>
  )
}

Post.propTypes = {
  post: PropTypes.object.isRequired,
  authornote: PropTypes.string.isRequired,
  theme: PropTypes.object.isRequired
}

export default Post
